import React from 'react'
import { useFormContext } from 'react-hook-form'

import NumberField from 'components/layout/form/fields/NumberField'
import PictureField from 'components/layout/form/fields/PictureField'
import RadiosField from 'components/layout/form/fields/RadiosField'
import TextareaField from 'components/layout/form/fields/TextareaField'
import TextField from 'components/layout/form/fields/TextField'
import { formatToUpperCase } from 'utils/form'


const Ventilation = () => {
  const { readOnly } = useFormContext()
  return (
    <>
      <TextField
        label="Etiquette : "
        name="label"
        placeholder="Ex. : A1"
      />
      <NumberField
        label="Hauteur au sol : "
        name="fromGroundHeight"
        placeholder="Ex. : 0,95"
        unitLabel='m'
      />
      <TextField
        format={formatToUpperCase}
        label="Plancher ou T.N. de référence : "
        name="baseFlooring"
        placeholder="Ex. : N0"
      />
      <RadiosField
        isBoolean
        label="Occultation existante "
        name="hasConcealment"
      />
      <TextareaField
        label="Commentaire sur l'occultation existante : "
        name="batardeauComment"
      />
      <TextareaField
        label="Commentaire ouvrant : "
        name="comment"
      />
      <PictureField
        folderPath="photos"
        label={`Photo${readOnly ? '' : ' (facultatif)'} :`}
        name="photo"
      />
    </>
  )
}

export default Ventilation
